import { useState } from "react"

export const Career = () => {
	const [posterList, setPosterList] = useState([])
	const [loader, setLoader] = useState(true)
	const [openModal, setOpenModal] = useState({ template: false, custom: false })
	const [form, setForm] = useState({  confirmation: false, error: false, loader: false, method: 'create', saving_type: '', with_job_acc: false, violator: false,
		// company_logo: {value: '', object: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753767188732.png", name: "Ellipse 751.png", size: 1848, type: "default",  stat: false, msg: ''},
		// ft_image: {value: '', object: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753766821641.png", name: "image 17.png", size: 81516, type: "default",  stat: false, msg: ''},
		// bg_image: {value: '', object: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753782085010.png", name: "Group 57799", size: 208676, type: "default",  stat: false, msg: ''},
		// violator_image: {value: '', object: "https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753766821543.png", name: "vector_img.png", size: 289, type: "default",  stat: false, msg: ''},
		// company_name: 'Yans Corp.', tagline: 'Be part of our Extraordinary and Heroic Journey', work_location: '', job_vacancy: '', 
		// link: '',  poster_name: '',   
		// qualification: [ 
		//     {value: "Integrate applocations with REST APIS", stat: false, msg: ''}, 
		//     {value: "Knowledge of GIT/Bucket", stat: false, msg: ''},
		//     {value: "Strong problem-solving", stat: false, msg: ''},
		//     {value: "Develop and maintain mobile application Integrate applocations with REST APIS", stat: false, msg: ''},

		// ],
		// company_name_color: "#5B6167", tagline_color: "#292C2F",
		// job_vacancy_color: "#22A06B", location_color: "#283745", qualification_bg: "#D6D9DB8F",
		// qualification_text_color: "#292C2F", qualification_list_color: "#292C2F"
	})
	const [templateList, setTemplateList] = useState([])
	const [templateLoader, setTemplateLoader] = useState(true)
	const [selectedTemplate, setSelectedTemplate] = useState(null)
	const [custom, setCustom] = useState('')
	const [job, setJob] = useState({list: [], qualification: []})
	const [copied, setCopied] = useState(false);
	const [preview, setPreview] = useState({open: false, image: ''});
	const [formLoader, setFormLoader] = useState(true);
	const [required, setRequired] = useState([])
	return {
		posterList: {data: posterList, set: setPosterList},
		loader: {data: loader, set: setLoader},
		openModal: {data: openModal, set: setOpenModal},
		form: {data: form, set: setForm},
		templateList: {data: templateList, set: setTemplateList},
		templateLoader: {data: templateLoader, set: setTemplateLoader},
		selectedTemplate: {data: selectedTemplate, set: setSelectedTemplate},
		custom: {data: custom, set: setCustom},
		job: {data: job, set: setJob},
		copied: {data: copied, set: setCopied},
		preview: {data: preview, set: setPreview},
		formLoader: {data: formLoader, set: setFormLoader},
		required: {data: required, set: setRequired},
	}
}
